<template>
    <div>
        <accordion      
            id="dados" 
            title="Dados"
            class="col-12 mt-3" 
            accordion="rn3162"            
            hide-title
        >
            <div class="row p-3">
                <input-text class="col-12" label="Titulo" v-model="form.titulo" ref="titulo" required/>
                <input-text class="col-12 col-md-3" label="Código" v-model="form.codigo" ref="codigo" required/>
                <input-text class="col-12 col-md-3" label="Ano inicio" type="number" :min="1960" :max-length="4" v-model="form.anoInicio" ref="anoInicio" required/>
                <input-text class="col-12 col-md-3" label="Ano fim" type="number" :min="1960" :max-length="4" v-model="form.anoFim" ref="anoFim" required/>
                <input-select class="col-12 col-md-3" label="Fase de inovação" :options="options.fases" v-model="form.faseInovacao" ref="fase" required/>
                <div class="col-12">
                    <b-button v-if="form.id ? permissaoGeral.c : permissaoGeral.u" @click="salvar" variant="success">
                        <i class="fa-solid fa-check mr-2"></i>
                        Salvar
                    </b-button>
                </div>
            </div>
        </accordion>


        
        <accordion 
            v-if="form.id && permissaoDesembolso.r"
            id="desembolso" 
            title="Desembolsos"
            class="col-12 mt-3" 
            accordion="rn316"       
        >
            <desembolsos :projeto-id="form.id" :dados="form.desembolsos" @update="buscar"/>
        </accordion>
        

        <accordion      
            v-if="form.id && permissaoCusto.r"
            id="custos" 
            title="Custos próprios"
            class="col-12 mt-3" 
            accordion="rn316"

        >
            <custos :projeto-id="form.id" :dados="form.custosProprios" @update="buscar"/>
        </accordion>
    </div>
</template>
<script>
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import helpers from "@/common/utils/helpers";
import {FormMixin} from "@/common/mixins/FormMixin";
import {AlertasMixin} from "@/common/mixins/AlertasMixin";

import Accordion from '@/components/card/Accordion';

import Desembolsos from "./accordions/desembolsos";
import Custos from "./accordions/custos";
import cloneDeep from "lodash/cloneDeep";
import { START_LOADING, STOP_LOADING } from "@/store/Store";
import { DEFINIR_BREADCRUMB } from "@/store/breadcrumbs.module";

import MovimentacaoFinanceiraService from "@/common/services/movimentacao_financeira/movimentacao_financeira.service";

export default {
    mixins: [FormMixin, AlertasMixin],
    props: {
        id: {
            type: String,
            default: null
        },
    },
    components : {
        InputText,
        InputSelect,
        Accordion,
        Desembolsos,
        Custos,
    },
    data : () => ({
        options : {
            meses : helpers.retornarMeses(),
            rubricas : helpers.getRubricas(),
            fases : helpers.FaseInovacao,
        },
        form : {
            titulo : '',
            codigo : '',
            anoInicio : '',
            anoFim : '',
            desembolsos : [],
            custosProprios : [],
        }
    }),
    mounted() {
        this.$store.dispatch(DEFINIR_BREADCRUMB, [
            {titulo : "Projetos encerrados RN 316 (Regra nova)", to: {name: "projeto-316-lista"}},
            {titulo : "Detalhes"}
        ]);
        
        this.buscar();
    },
    methods : {
        buscar : function(){
            if(!this.id)
                return;

            this.$store.dispatch(START_LOADING);
            MovimentacaoFinanceiraService.buscarProjetoRN316(this.id).then(res => {
                this.form = res.data.data;
            }).finally(() => {
                this.$store.dispatch(STOP_LOADING);
            });
        },
        salvar : function(){
            let form = cloneDeep(this.form);
            if(!this.validateState())
                return;

            this.confirmar('Aviso','Deseja salvar projeto?').then(confirmado => {
                if(confirmado){

                    form.EmpresaId = this.empresaSelecionada;

                    this.$store.dispatch(START_LOADING);
                    MovimentacaoFinanceiraService.salvarProjetoRN316(form).then(() => {
                        this.alertaSucesso('Salvo com sucesso!').then(() => {
                            if(!form.id){
                                this.$router.push({ name: 'projeto-316-lista'});
                            }
                            this.buscar();
                        });
                    }).catch(err => {
                         if(err.response.status == 400){
                            this.alertaErro(err.response.data.errors);
                        }else   
                            this.alertaErro("Erro ao salvar");
                    }).finally(() => {
                        this.$store.dispatch(STOP_LOADING);
                    });
                }
            })
        },
    },
    computed : {
        empresaSelecionada : function(){
            return this.$store.state.app.selectedCompanyObj.id;
        },
        permissaoGeral() {
            return this.$store.getters['app/retornaPermissao']('ProjetosRn316');
        },
        permissaoDesembolso() {
            return this.$store.getters['app/retornaPermissao']('ProjetosRn316Desembolsos');
        },
        permissaoCusto() {
            return this.$store.getters['app/retornaPermissao']('ProjetosRn316Custos');
        },
    }
}
</script>
<style>
</style>